module.exports = __webpack_public_path__ + "public/images/why-outschool-squiggle.b9104298593b8c895aeeb06f7bfbde3d.webp";